<template>
  <div class="member__weekly">
    <div class="top">
      <div class="title">学习周报</div>
      <span class="week__view_btn" @click="goStudy">查看完成周报<span class="icon-right"></span></span>
    </div>
    <div class="study__week" @click="goStudy">
      <div class="item">
        <div class="item-top">
          <div v-if="isLocked" class="img1"></div>
          <template v-else>
            <div class="item-num">{{ num || '--' }}</div>
            <div v-if="num !== ''" class="item-unit">题</div>
          </template>
        </div>
        <div class="item-desc">答题量</div>
      </div>
      <div class="border"></div>
      <div class="item">
        <div class="item-top">
          <div v-if="isLocked" class="img2"></div>
          <template v-else>
            <div class="item-num">{{ percent || '--' }}</div>
            <div v-if="percent !== ''" class="item-unit">%</div>
          </template>
        </div>
        <div class="item-desc">正确率</div>
      </div>
      <div class="border"></div>
      <div class="item">
        <div class="item-top">
          <div v-if="isLocked" class="img3"></div>
          <template v-else>
            <div class="item-num">{{ rank || '--' }}</div>
            <div v-if="rank !== ''" class="item-unit">名</div>
          </template>
        </div>
        <div class="item-desc">本周排名</div>
      </div>
    </div>

  </div>
</template>

<script>
import wx from 'weixin-js-sdk';

export default {
  props: {
    weeklyInfo: {
      value: Object,
      default: () => ({}),
    },
    userMemberInfo: {
      type: Object,
      default: () => ({
        level: 0, // 0 普通用户 10 试用会员 20 基础会员 25 VIP 30 SVIP
        levelName: '普通用户',
        deadlineStartTime: '',
        deadlineEndTime: '', // 会员到期时间
        isTryoutMember: null, // 是否领取过试用会员
        beforeMemberLevel: null, // 上一次会员等级
      }),
    },
  },
  data() {
    return {
      num: '',
      percent: '',
      rank: '',
      id: '',
      isApp: this.$root.$data.isApp || false,
    };
  },
  computed: {
    // 未开通会员展示占位图；已开通（含 VIP 25）展示周报数据
    isLocked() {
      return ![10, 20, 25, 30, 40, 50, 60].includes(this.userMemberInfo.level);
    },
  },
  methods: {
    goStudy() {
      if (this.isApp) {
        this.$sendToApp('openNewWebView', { url: `${origin}/ark/weekReport/detail?weekId=${this.id}&isShowFont=true` }, false);
      } else if (this.$root.miniprogram) {
        const url = window.location.href;
        const [, searchParams] = url.split('?');
        const { origin } = window.location;
        let path = `${origin}/ark/weekReport/detail?weekId=${this.id}&isShowFont=true&`;
        const params = searchParams.split('&');
        if (params) {
          const paramsMap = new Map();
          params.forEach((item) => {
            const [key, value] = item.split('=');
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (ExcludequeryArr.includes(key) && value) query += `${key}=${value}&`;
          }
          path += query;
        }
        const jumpUrl = `/subPackages/webView/webView?url=${encodeURIComponent(path)}`;
        wx.miniProgram.navigateTo({
          url: jumpUrl,
        });
      } else {
        const miniBeforePageName = localStorage.getItem('miniBeforePageName');
        if (!miniBeforePageName) {
          localStorage.setItem('miniBeforePageName', 8);
        }
        this.$router.push({
          path: '/weekReport/detail',
          query: {
            weekId: this.id,
            isShowFont:true,
          },
        });
      }
    },
  },
  watch: {
    weeklyInfo: {
      handler(value) {
        console.log(111111, value);
        if (value !== null) {
          const {
            questionCount, correctRatio, rank, id,
          } = value;
          this.num = `${questionCount || ''}`;
          this.percent = `${correctRatio || ''}`;
          this.rank = `${rank || ''}`;
          this.id = `${id || ''}`;
        } else {
          this.num = '';
          this.percent = '';
          this.rank = '';
          this.id = '';
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../index.scss';

.member__weekly {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 678px;
  margin: 0 auto 36px;
}

.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 40px;
  margin-bottom: 22px;
}

.title {
  color: #333;
  font-weight: 500;
  font-size: 29px;
  line-height: 40px;
}

.week__view_btn {
  display: flex;
  align-items: center;
  height: 31px;
  color: #999;
  font-weight: 400;
  font-size: 22px;

  .icon-right {
    @include background(9px, 16px);
    @include backgroundImage('member_week_right.png');

    margin-left: 7px;
  }
}

.study__week {
  display: flex;
  align-items: center;
  width: 678px;
  height: 174px;
  background: #FFF;
  border-radius: 14px;

  .border {
    width: 2px;
    height: 47px;
    background: #F6F6F6;
  }

  .item {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;

    &-top {
      display: flex;
      align-items: flex-end;
      height: 72px;

      .img1 {
        @include background(103px, 72px);
        @include backgroundImage('member_week-1.png');
      }

      .img2 {
        @include background(152px, 72px);
        @include backgroundImage('member_week-2.png');
      }

      .img3 {
        @include background(123px, 72px);
        @include backgroundImage('member_week-3.png');
      }
    }

    &-num {
      height: 40px;
      color: #333;
      font-weight: normal;
      font-size: 36px;
      line-height: 42px;
    }

    &-unit {
      height: 31px;
      color: #333;
      font-weight: 400;
      font-size: 22px;
      line-height: 31px;
    }

    &-desc {
      height: 36px;
      color: #999;
      font-weight: 400;
      font-size: 25px;
      line-height: 36px;
    }
  }
}
</style>
